import styled from "styled-components";

export const ContainerBanner = styled.div`
  background-image: ${(props) => `url('${props.img}')`};
  background-repeat: no-repeat;
  background-position: top right;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid #f0f2f9;
  margin-top: 64px;
  padding: 12px 24px;

  @media only screen and (min-width: 769px) {
    border-radius: 16px 16px 0px 0px;
    margin-top: 24px;
  }
`;

export const ImageBadge = styled.img`
  width: 64px;
  height: 52px;
`;

export const Typography = styled.p`
  font-family: Gilroy;
  color: ${(props) => props?.color ?? "#1F2D3D"};
  font-size: ${(props) => props?.fontSize ?? "18px"};
  font-weight: ${(props) => props?.fontWeight ?? 400};
  line-height: ${(props) => props?.lineHeight ?? "24px"};
  margin: 0;
  display: flex;
`;

export const Pillbox = styled.span`
  background-color: ${(props) => props?.bgColor ?? "#FFF"};
  border-radius: 4px;
  color: #fff;
  font-family: Gilroy;
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
  padding: 2px 4px;
  margin-left: 8px;
`;

export const CopyText = styled.span`
  color: #00bcf1;
  font-family: Gilroy;
  font-size: 12px;
  font-style: normal;
  font-weight: 800;
  line-height: 16px;
  margin-left: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ContainerDetail = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px 24px 16px 24px;

  @media only screen and (min-width: 769px) {
    border-radius: 0px 0px 16px 16px;
    border: 1px solid #f0f2f9;
  }
`;

export const ContainerPaymentDetail = styled.div`
  background-image: ${(props) => `url('${props.img}')`};
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px;
  border: 1px solid #f0f2f9;
  border-radius: 8px;
  box-shadow: 0px 4px 4px 0px rgba(140, 140, 140, 0.07);
  row-gap: 8px;
`;

export const ContainerCountdown = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
`;

export const ContainerPaymentProof = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  gap: 4px;
`;

export const ContainerNavigation = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 16px 24px 100px 24px;
`;

export const ButtonNavigation = styled.button`
  width: 128px;
  height: 44px;
  color: ${(props) => props?.color ?? "#1F2D3D"};
  font-size: 16px;
  font-weight: 800;
  background-color: ${(props) => props?.bgColor ?? "#FFF"};
  border-radius: 40px;
  border: 1px solid ${(props) => props?.color ?? "#1F2D3D"};
  cursor: ${(props) => props?.cursor ?? "pointer"};
`;
